import React, { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';

interface DateSelectorProps {
  availableDates: string[];
  selectedDate: string | null;
  onDateChange: (date: string) => void;
}

export const DateSelector: FC<DateSelectorProps> = ({
  availableDates,
  selectedDate,
  onDateChange,
}: DateSelectorProps) => {
  const { t } = useTranslation();

  const handleDateChange = (event: SelectChangeEvent<string>): void => {
    onDateChange(event.target.value);
  };

  if (availableDates.length === 0) {
    return null;
  }

  return (
    <div className="rounded-md bg-gray-100 px-2 py-1">
      <FormControl variant="outlined" size="small">
        <InputLabel id="date-selector-label">{t('route_date_selector')}</InputLabel>
        <Select
          variant="outlined"
          labelId="date-selector-label"
          value={selectedDate || ''}
          onChange={handleDateChange}
          label={t('route_date_selector')}
          sx={{ minWidth: '11rem' }}
        >
          {availableDates.map((date: string) => (
            <MenuItem key={date} value={date}>
              {format(parseISO(date), 'dd/MM/yyyy')}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
